import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./performance.css";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter as Router } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { PAYPAL_OPTIONS } from "./config/paypal.js";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <PayPalScriptProvider options={PAYPAL_OPTIONS}>
      <Router>
        <App />
      </Router>
    </PayPalScriptProvider>
  </StrictMode>
);
